import React from 'react';
import { Card, Container} from 'react-bootstrap';
import { Link } from 'react-router-dom';

import logo from '../Assets/logo.png';


export default function ClientThankYou(){
    return (
        <>
            <Container className="d-flex align-items-center justify-content-center mt-5" style={{minHeight: "60vh"}}>
                <div className="w-100" style={{maxWidth: "600px"}}>
                    <Card>
                        <Card.Img variant="top" src={logo} style={{width:"50%", alignSelf:"center", paddingTop:"20px"}}/>
                        <Card.Body>
                            <h2 className="text-center mb-4">Thank You for Signing Up</h2>
                            <h4>
                                Once The Proven Group has authorized your account you will be able to log into the Client Portal
                            </h4>
                        </Card.Body>
                    </Card>
                    <div className="w-100 text-center mt-2">
                        Return to <Link to="/client-login">Log_in</Link>
                    </div>
                </div>
            </Container>
        </>
    );
}